// STARTER QUERY PARAMETERS
export const CHECKOUT = 'checkout';

// Parameters attached post-purchase to denote Hubs just purchased, and non-free Hubs the customer had at the time of purchase
export const MARKETING_STARTER = 'marketing-starter';
export const SALES_STARTER = 'sales-starter';
export const SERVICE_STARTER = 'service-starter';
export const CMS_STARTER = 'cms-starter';
export const OPS_STARTER = 'operations-starter';